<template>
    <div class="popover-wrap"
        v-if="visible">
        <div class="flex-x-between-middle popover-header">
            <span>
                {{succNum}} 个文件上传完成
                <template v-if="failNum">
                    ，{{failNum}} 个失败
                </template>
            </span>
            <div>
                <i :class="['popover-header-btn', isFold ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
                    @click.stop="isFold = !isFold"></i>
                <i class="el-icon-close popover-header-btn"
                    @click.stop="hide"></i>
            </div>
        </div>
        <ul class="popover-body"
            :class="isFold ? 'folded' : ''">
			<template v-for="(item, index) in fileList">
				<list-item
					v-if="index <= ( succNum + failNum )"
					:key="item.file && item.file.uid ? item.file.uid : index"
					:data="item"
					@uploadSucc="succNum++"
					@uploadFail="failNum++"></list-item>
			</template>
        </ul>
    </div>
</template>
<script>
/*
调用：this.$uploadFilePopover
方法：show
    params: Object
        api：轮询api
        params: api参数
        pollRequest：Boolean 是否是轮询请求,默认不传为false
        file：上传的文件对象
        route：上传成功后，点击文件夹按钮，跳相应页面，一般为结果查询页面
方法：hide 隐藏弹窗
方法：clear 清空之前上传内容
*/
import ListItem from './list-item'

export default {
	components: { ListItem },
	data () {
		return {
			visible: false,
			fileList: [],
			isFold: false, // 折叠true、展开flase
			succNum: 0,
			failNum: 0
		}
	},
	methods: {
		addFile (opts) {
			this.visible = true
			if (typeof (opts.api) !== 'function') {
				console.error('API格式不正确！')
				return
			}
			this.fileList.unshift(opts)
		},
		show () {
			this.visible = true
		},
		hide () {
			this.visible = false
			this.clear()
		},
		clear () {
			this.fileList = []
			// this.fileList.splice(0)
			this.succNum = 0
			this.failNum = 0
		}
	}
}
</script>
<style lang="scss" scoped>
.popover- {
    &wrap {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 999999;
        background: #fff;
        box-shadow: 2px 4px 10px 1px #666;
        width: 500px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        overflow: hidden;
    }
    &header {
        color: #fff;
        background: #666;
        padding: 15px;
        &-btn {
            cursor: pointer;
            padding: 0 6px;
        }
    }
    &body {
        height: 250px;
        overflow-y: auto;
        transition: height ease-in-out .5s;
        &.folded {
            height: 0;
        }
    }
}
</style>
